import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownItem } from '../../models/commonModel';
import { MaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-confirmationtab',
  templateUrl: './confirmationtab.component.html',
  styleUrls: ['./confirmationtab.component.scss'],
})
export class ConfirmationtabComponent implements OnInit, OnChanges {
  licenseContractorsText: string = `Applicant(s) company has an active license issued by the State Board for Licensing Contractors. This is not your local business license (see below). This could include a Contractors License (for projects $25,000 or more), a Home Improvement License (for projects less than $25,000), a Limited Licensed Electrician, or a Limited Licensed Plumber. If you are unsure if your business has one of the licenses, you can search https://verify.tn.gov/. If your business does not have a license from the State Board for Licensing Contractors, please ensure the check box is unchecked.`;
  stillAffiliatedCheckBox: string = `By checking this box, I attest that I am still affiliated with the business under which I originally qualified and I still meet the ownership requirements.`;
  attestToTCACheckBox: string = `By checking this box, I attest that I meet all the requirements for the workers' compensation exemption under T.C.A. §50-6-901 et seq. I understand that any false statement I make on the application is subject to the penalties of perjury set out in T.C.A. §39-16-702.`;
  attestToTCA903CheckBox: string = `By checking this box, I attest that I meet all the requirements for the workers' compensation exemption under T.C.A. §50-6-903 et seq. I understand that any false statement I make on the application is subject to the penalties of perjury set out in T.C.A. §39-16-702.`;
  waveRightsToSueCheckBox: string = `By checking this box, I understand that I waive my right to sue under workers' compensation law if I am injured on a job and have utilized the workers' compensation exemption on that job.`;
  registeredApplicantCheckBox: string = `By checking this box, I attest that I am the applicant registered with the information noted above and I voluntarily choose to revoke my workers' compensation exemption registration. I understand that any false statement I make on the application is subject to the penalties of perjury set out to T.C.A. §39-16-702.`;
  yesHaveInjuryCheckBox: string = `I DO have an employment related injury that occurred while providing services to a person or entity that did not provide coverage under a policy of workers' compensation.`;
  dontHaveInjuryCheckBox: string = `I DO NOT have an employment related injury that occurred while providing services to a person or entity that did not provide coverage under a policy of workers' compensation.`;
  filingDate: string = '';
  applicantName: string = '';

  stillAffCbFtype = ['RENEWAL'];
  stillAffCbQtype = ['RELSECTBUSINESSENT', 'RELSECTSOLEPROP'];
  aTcaCbFtype = ['RENEWAL', 'INITIAL', 'SUBSEQUENT', 'REINSTATE', 'CORRECTION'];
  aTca903CbQtype = ['RELSECTBUSINESSENT', 'RELSECTSOLEPROP'];
  rightSueFtype = [
    'RENEWAL',
    'INITIAL',
    'SUBSEQUENT',
    'REINSTATE',
    'CORRECTION',
  ];
  rightSueQtype = ['RELSECTBUSINESSENT', 'RELSECTSOLEPROP'];
  regApFtype = ['VOLREVOCATION'];
  doHvInjutyFtype = ['VOLREVOCATION'];

  @Input()
  FillingType: any;
  @Input()
  CsPLicense: any;
  @Input()
  ParentForm!: FormGroup;
  @Input()
  ConfirmationTab!: FormGroup;

  @Input()
  QualificationTypes!: DropdownItem[];
  @Input()
  CountyTypes!: DropdownItem[];
  @Input()
  CityTypes!: DropdownItem[];
  @Input()
  StateTypes!: DropdownItem[];
  @Input()
  IsExternal = false;
  dontHaveInjury = false;
  yesHaveInjury = false;
  @Input()
  injuryMode: any;
  @Output() oninjuryModeChanged: EventEmitter<any> = new EventEmitter();
  constructor(
    private formBuilder: FormBuilder
  ) {}
ngOnChanges() {
  console.log(this.CsPLicense);
}
  ngOnInit(): void {
    console.log("injury ------> ", this.injuryMode);
  }
  onCheck(value: any, event: any) {
    if (!event.checked) value = null;
    this.injuryMode = value;
    this.oninjuryModeChanged.emit(this.injuryMode);
  }
  getValue(tabName: string, fieldName: string) {
    return (this.ParentForm.controls[tabName] as FormGroup)?.controls[fieldName]
      .value;
  }

  getFormattedPhone() {
    let phone = this.getValue('QualificationTab', 'contactPhone');
    if (phone && phone.length == 10) {
    }
  }

  getApplicantName() {
    var fname = this.getValue('QualificationTab', 'firstName') || '';
    var lname = this.getValue('QualificationTab', 'lastName') || '';
    return `${fname} ${lname}`;
  }

  getMailingAddress() {
    var addr1 = this.getValue('MailingAddressTab', 'address1');
    var addr2 = this.getValue('MailingAddressTab', 'address2');
    var city = this.getValue('MailingAddressTab', 'city');
    var state = this.getState(this.getValue('MailingAddressTab', 'stateId'));
    var zip = this.getValue('MailingAddressTab', 'zipCode');
    if (zip && zip.length == 9) {
      //zip = zip.substring(0, 4) + '-' + zip.substring(5, 9);
      zip = zip.substring(0, 5) + '-' + zip.substring(5, 9);  
    }
    return `${addr1 ? addr1 + '\n' : ''} ${addr2 ? addr2 + '\n' : ''} 
              ${city ? city + ', ' : ''}  ${state ? state : ''} ${
      zip ? zip : ''
    }`;
  }

  getPhysicalAddress() {
    var addr1 = this.getValue('PhysicalAddressTab', 'address1');
    var addr2 = this.getValue('PhysicalAddressTab', 'address2');
    var city = this.getValue('PhysicalAddressTab', 'city');
    var state = this.getState(this.getValue('PhysicalAddressTab', 'stateId'));
    var zip = this.getValue('PhysicalAddressTab', 'zipCode');
    if (zip && zip.length == 9) {
      //zip = zip.substring(0, 4) + '-' + zip.substring(5, 9);
      zip = zip.substring(0, 5) + '-' + zip.substring(5, 9);
    }
    return `${addr1 ? addr1 + '\n' : ''} ${addr2 ? addr2 + '\n' : ''} 
            ${city ? city + ', ' : ''}  ${state ? state : ''} ${
      zip ? zip : ''
    }`;
  }

  getCity(cityId: any) {
    if (cityId == null || cityId == undefined) return;
    return this.CityTypes.find((x) => x.id == cityId)?.name;
  }
  getState(stateId: any) {
    if (!stateId) return;
    return this.StateTypes.find((x) => x.id == stateId)?.abbrv;
  }

  getCounty(countyId: any) {
    if (countyId == null || countyId == undefined) return;
    return this.CountyTypes.find((x) => x.id == countyId)?.name;
  }

  getQualificationType() {
    var qTypeId = this.getValue('QualificationTab', 'qualificationType');
    if (!qTypeId) return;
    return this.QualificationTypes.find((x) => x.id == qTypeId)?.description;
  }

  getQualificationTypeCode() {
    var qTypeId = this.getValue('QualificationTab', 'qualificationType');
    if (!qTypeId) return;
    return this.QualificationTypes.find((x) => x.id == qTypeId)?.code;
  }

  checkAttestTCA() {
    const is903 =
      this.aTcaCbFtype.includes(this.FillingType) &&
      this.aTca903CbQtype.includes(this.getQualificationTypeCode());
    return is903;
  }
}
